import {
  Dialog,
  DialogPanel,
  Transition,
  TransitionChild,
} from "@headlessui/react";
import React, { Fragment } from "react";

/**
 * Renders a ModalPopUp component with customizable options.
 *
 * @param {Object} props - The properties object containing children, show, maxWidth, closeable, onClose, and panelClass
 * @return {JSX.Element} The rendered ModalPopUp component
 */
const ModalPopUp = ({
  children,
  show = false,
  maxWidth = "2xl",
  closeable = true,
  onClose = () => {
    // console.log("ModalPopUp onClose");
  },
  panelClass = "",
  panelContainerClass = "",
}) => {
  /**
   * A function that checks if it's closeable and if so, calls the onClose function.
   */
  const close = () => {
    if (closeable) {
      onClose();
    }
  };
  var maxWidthClass = {
    sm: "sm:max-w-sm",
    md: "sm:max-w-md",
    lg: "sm:max-w-lg",
    xl: "sm:max-w-xl",
    "2xl": "sm:max-w-2xl",
  }[maxWidth];

  return (
    <Transition appear show={show} as={Fragment} leave="duration-200">
      <Dialog
        as="div"
        id="modal"
        className="fixed inset-0 z-[1033] flex transform px-4 py-6 transition-all"
        onClose={close}
      >
        {/*  The backdrop */}
        <div
          className="fixed inset-0 left-0 top-0 h-screen w-full bg-black/25"
          aria-hidden="true"
        />

        {/* The modal panel container */}
        <div
          className={`fixed inset-0 w-screen overflow-y-auto px-3 py-8 ${panelContainerClass}`}
        >
          <TransitionChild
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            enterTo="opacity-100 translate-y-0 sm:scale-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100 translate-y-0 sm:scale-100"
            leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          >
            <DialogPanel
              className={`mx-auto transform rounded-lg bg-white p-4 shadow-xl transition-all sm:w-full sm:p-6 ${panelClass}`}
            >
              {children}
            </DialogPanel>
          </TransitionChild>
        </div>
      </Dialog>
    </Transition>
  );
};

export default ModalPopUp;
